import Alpine from "alpinejs";

interface MenuStore {
  isOpen: boolean;
  colorType: string;
  windowHeight: number;
  syncBodyScroll: () => void;
  toggleClassHome: () => void;
  closeMenu: () => void;
  closeOnDesktop: () => void;
  toggleMenu: () => void;
  changeColor: (el: HTMLElement, colorType: string) => void;
}

export const menu = () => {
  /**
   * 慣性スクロールの」処理
   */
  const lenis = window.lenis;

  // 画面高さを取得
  const windowHeight = window.innerHeight;
  const header = document.querySelector("header");

  Alpine.store("menu", {
    isOpen: false, // ham menuの開閉チェック
    colorType: "beige",
    windowHeight: windowHeight,

    syncBodyScroll() {
      const body = document.body;
      if (!body) return;

      if (this.isOpen) {
        body.style.overflow = "hidden";
        lenis?.stop?.();
      } else {
        body.style.overflow = "";
        lenis?.start?.();
      }
    },

    /**
     * Home Page専用Style
     */
    toggleClassHome() {
      if (!header) return;

      // Home Pageの場合
      if (header.classList.contains("type-home")) {
        const sectionMv = document.getElementById("home-mv");
        if (!sectionMv) return;

        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                header.classList.remove("type-ham");
              } else {
                header.classList.add("type-ham");
              }
            });
          },
          {
            root: null,
            rootMargin: `-${windowHeight * 0.5}px 0px 0px 0px`,
            threshold: 0,
          }
        );
        io.observe(sectionMv);
      }
    },

    /**
     * Ham Menu の On/Off
     */
    closeMenu() {
      this.isOpen = false;
      this.syncBodyScroll();
    },

    closeOnDesktop() {
      if (window.innerWidth >= 768 && this.isOpen) {
        this.closeMenu();
      }
    },

    toggleMenu() {
      this.isOpen = !this.isOpen;
      this.syncBodyScroll();
    },
    // Headerのカラーを背景色に応じて変更
    changeColor(el: HTMLElement, colorType: string) {
      const windowHeight = window.innerHeight;
      const setMargin = windowHeight - 60;

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              let mainColor;
              let reverseColor;
              if (colorType === "beige") {
                mainColor = "#E9E2D2";
                reverseColor = "#414A47";
                this.colorType = "beige";
              } else {
                mainColor = "#414A47";
                reverseColor = "#E9E2D2";
                this.colorType = "black";
              }
              document.documentElement.style.setProperty("--header-color", mainColor);
              document.documentElement.style.setProperty("--header-color-reverse", reverseColor);
            }
          });
        },
        {
          root: null,
          rootMargin: `0px 0px -${setMargin}px 0px`,
          threshold: 0,
        }
      );
      io.observe(el);
    },
  } as MenuStore);
};
